import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';

import MarqueeWithCookies from '../components/Marquee/MarqueeWithCookies';
import Ribbon from '../containers/Ribbon';
import NFTs from '../components/NFTs';
// import WhoAmI from '../components/WhoAmI';
import WorkContainer from '../containers/Work';
import AboutContainer from '../containers/About';

class Home extends PureComponent {
  render() {
    return (
      <div>
        <Helmet
          title="generative artist lucastswick"
          description="lucastswick is a generative artist writing algorithms that describe natural phenomena."
        />
        <MarqueeWithCookies />
        <Ribbon height={50} />
        <NFTs />
        {/* <WhoAmI /> */}
        <WorkContainer />
        <AboutContainer />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js